import {
  FormField,
} from '@codev/helix-react';
import PropTypes from 'prop-types';
import React from 'react';
import schemeNames from '../schemeNames.js';
import SchemePanel from './SchemePanel.jsx';
import FormFieldLayout from './FormFieldLayout.jsx';
import translations from './translations.js';

const View = ({
  language = 'en_US',
  onSelectScheme,
  onTooltipShow,
  schemeSelected,
  style,
  useForRecovery,
  ...rest
}) => (
  <div
    {...rest}
    style={{
      fontSize: '16px',
      ...style
    }}
  >
    <p>{translations(`stepText${useForRecovery ? 'ForRecovery' : ''}`, language)}</p>

    <FormField
      isRequired
      isRequiredErrorMessage={translations('authMethodRequiredMessage', language)}
      layout={FormFieldLayout}
      shareValidationState
      style={{
        paddingRight: 0,
      }}
      value={schemeSelected}
    >
      <SchemePanel
        description={translations('panel1Description', language)}
        methodName={translations('panel1MethodName', language)}
        onSelect={() => onSelectScheme(schemeNames.sms)}
        selected={schemeSelected === schemeNames.sms}
        helpText={translations('panel1Tooltip', language)}
      />
      <SchemePanel
        description={translations('panel2Description', language)}
        methodName={translations('panel2MethodName', language)}
        onSelect={() => onSelectScheme(schemeNames.googleAuth)}
        onTooltipShow={() => onTooltipShow(schemeNames.googleAuth)}
        selected={schemeSelected === schemeNames.googleAuth}
        toolTipContent={translations('panel2Tooltip', language)}
        toolTipLinkText={translations('panel2TooltipLink', language)}
      />
    </FormField>
  </div>
);

View.defaultProps = {
  onTooltipShow: () => {},
  useForRecovery: false,
};

View.propTypes = {
  onSelectScheme: PropTypes.func.isRequired,
  onTooltipShow: PropTypes.func,
  schemeSelected: PropTypes.oneOf([schemeNames.sms, schemeNames.googleAuth]),
  style: PropTypes.object,
  useForRecovery: PropTypes.bool,
};

export default View;